import { createFileRoute } from "@tanstack/react-router";
import { IntegrateGetStartedPage } from "@/features/agent-integrate/pages/get-started-page";

// Thin shim: the Integrate landing is static content — no search params, nothing to
// prefetch — so it only mounts the feature page. The shell (breadcrumbs, title, tabs)
// belongs to the parent layout.
export const Route = createFileRoute("/_authed/tenants/$slug/agents/integrate/")({
  component: IntegrateGetStartedPage,
});
